export type queryInterface = Record<string, any>;

const queryBuilder = (query: queryInterface, addQuestionMark: boolean): string => {
  const queryObj = {};
  Object.entries(query).forEach(([key, value]) => {
    if (value) {
      queryObj[key] = value;
    }
  });
  const params = new URLSearchParams(queryObj);
  const questionMark = addQuestionMark && Object.keys(queryObj)?.length ? '?' : '';
  return `${questionMark}${params.toString()}`;
};

export default queryBuilder;
